import React from 'react';
import { Link as MaterialUiLink, LinkProps } from '@mui/material';
import { ISharedProps } from '../../tools/ISharedProps';

interface ILinkProps extends LinkProps, ISharedProps {}

export const Link = ({ ...props }: ILinkProps) => <MaterialUiLink {...props} underline="hover" />;
